import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./cards.css";

const Events = ({ eventImg, eventTitle, button, index, featured }) =>  {
  const cardRef = useRef(null);

  useEffect(() => {
    const el = cardRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // stagger delay driven by the card's position index
          el.style.transitionDelay = `${index * 0.12}s`;
          el.classList.add("card-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [index]);

  return (
    <Link
      to={button}
      className={`event-card${featured ? " event-card--featured" : ""}`}
      ref={cardRef}
    >
      <img src={eventImg} alt={eventTitle} className="event-card-img" />

      {/* persistent bottom gradient so title is always legible */}
      <div className="event-card-gradient" />

      {/* orange overlay on hover */}
      <div className="event-card-overlay">
        <span className="event-card-label">See More</span>
      </div>

      {/* title — fades out when overlay appears */}
      <div className="event-card-footer">
        <span className="event-card-title">{eventTitle}</span>
      </div>
    </Link>
  );
};

export default Events;